import * as action from './actions';

export const getVendorLocations = (bundle) => {
  return {
    type: action.GET_VENDORLOCATIONS,
    payload: bundle,
  };
};

const ACTION_HANDLERS = {
  [action.SET_VENDORLOCATIONS]: (state, action) => {
    return { ...state, ...action.payload };
  },
  [action.GET_VENDORLOCATIONS]: (state, action) => {
    return { ...state, ...action.payload };
  },
};

let defaultState = {};

export const reducer = (state = defaultState, action) => {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
};
